// Copyright (c) 2025 MintJams Inc. Licensed under MIT License.

/**
 * Log level enumeration.
 */
export enum LogLevel {
    /** Debug level */
    DEBUG = 'debug',
    /** Info level */
    INFO = 'info',
    /** Warning level */
    WARN = 'warn',
    /** Error level */
    ERROR = 'error'
}
